// DEPRECATED: This component is deprecated. Use SpinningSun instead.
// This file exists only for backward compatibility.
import React from 'react';
import SpinningSun from './SpinningSun';

// Legacy wrapper - all new code should use SpinningSun directly
const LoadingSpinner = ({ message = 'Loading...', size = 'large', className = '' }) => {
  return (
    <SpinningSun 
      message={message} 
      size={size} 
      className={className}
      fullscreen={false}
    />
  );
};

export default LoadingSpinner;